import Vue, { CreateElement, VNode, VueConstructor } from "vue";
import { MessageLink, MessageLinkSubjectTypeEnum } from "@scrile/api-provider/dist/api/MessageLinksProvider";
import MessageItemLinkFeedView from "./MessageItemLinkFeedView.vue";
import MessageItemLinkStoryView from "./MessageItemLinkStoryView.vue";

export function getMessageItemLinkView(messageLink: MessageLink): VueConstructor<Vue> {
  switch (messageLink.subject.subjectType) {
    case MessageLinkSubjectTypeEnum.STORY:
      return MessageItemLinkStoryView;
    case MessageLinkSubjectTypeEnum.CONTENT_SET:
      return MessageItemLinkFeedView;
    default:
      return Vue.extend({
        functional: true,
        render: (h: CreateElement): VNode => h(),
      });
  }
}
